import { createFileRoute } from "@tanstack/react-router";
import { AuthFlow } from "@/components/auth-flows";

/** Legacy entry point for the account surface — /signin and /signup are canonical. */
export const Route = createFileRoute("/auth")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    const r = search["redirect"];
    return typeof r === "string" ? { redirect: r } : {};
  },

  head: () => ({
    meta: [
      { title: "Xamseen — Sign in" },
      { name: "description", content: "Join Xamseen to document local problems, support solutions and follow the issues that matter where you live." },
      { property: "og:title", content: "Join Xamseen" },
      { property: "og:description", content: "Document local problems, support solutions and follow the issues that matter where you live." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: AuthPage,
});

function AuthPage() {
  const { redirect } = Route.useSearch();
  return <AuthFlow initialMode="signin" redirectTo={redirect} />;
}
